// Minimal product analytics for the gifting surface. Intentionally separate
// from the funnel: distinct event names, a `surface: gifting` property, and no
// ad pixels. Wire a provider here (e.g. Mixpanel) when a token is configured.

type Props = Record<string, string | number | boolean | null | undefined>;

const listeners: Array<(name: string, props: Props) => void> = [];

export function onTrack(fn: (name: string, props: Props) => void): void {
  listeners.push(fn);
}

export function track(name: `Gift ${string}`, props: Props = {}): void {
  const payload = { surface: 'gifting', path: window.location.pathname, ...props };
  for (const fn of listeners) fn(name, payload);
  if (import.meta.env.DEV) console.debug('[analytics]', name, payload);
}
